import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const XIcon = (p: IconProps) => <Icon {...p}><path d="M18 6 6 18M6 6l12 12" /></Icon>
